/**
 * Product hotspot component
 * 
 * @module product-hotspot
 * @version 1.0.0 
 * @extends HTMLElement
 */

 customElements.component = 'product-hotspot';

 if (!customElements.get(customElements.component)) {
 
    class ProductHotspot extends HTMLElement {

     /**
     * Product hotspot web component
     * 
     * @constructor
     */
    constructor() {

        super();

        this.render();

    }

    /**
     * Render product hotspot
     * 
     * @returns {undefined}
     */
     render() {

        let productHandle = this.dataset.productHandle;

        window.theme.product.loadProduct(productHandle).then(product => {
            
            this.renderProduct(product);

        });

    }

    /**
     * Render product
     * 
     * @param {object} product A product object.
     * @returns {undefined}
    */

    renderProduct(product) {

        this.innerHTML = `<div class="product-hotspot__image">
            <img style="width: 100%;height: auto;" alt="${product.title}" loading="lazy" src="${product.images[0].src}" />
            <button class="product-hotspot__button">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-bottom" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.5 0.5V4.8955C1.50007 5.11875 1.54377 5.3398 1.62859 5.54602C1.71341 5.75224 1.8377 5.9396 1.99436 6.09738C2.15101 6.25516 2.33696 6.38029 2.54159 6.4656C2.74622 6.55092 2.96551 6.59476 3.18695 6.59461H10.5M7.59457 3.68811L10.5 6.61734L7.64076 9.5" fill="none" stroke-width="1.5" stroke-miterlimit="10"/>
                </svg>
            </button>
        </div>`;
        
        this.innerHTML += `<div class="product-hotspot__title">${product.title} | ${product.variants[0].sku}</div>`;

        let priceArry = [];

        product.variants.forEach(variant => {
            priceArry.push(variant.price);
        });

        let product_price = Math.min(...priceArry);

        product_price = theme.money.format(product_price);

        this.innerHTML += `<div class="product-hotspot__price">From ${product_price}</div>`;

        this.innerHTML = `<a class="product-hotspot__link" href="/products/${product.handle}">` + this.innerHTML + `</div>`;
    }

}

customElements.define(customElements.component, ProductHotspot);
}
